import { SxProps, Theme } from '@mui/material';
import { clsx, Colors, commonStyles } from '@sweatpals/react-ui-kit';
import { defaultHostColorHex } from '../../../host/pages/host/host-page.styles';

export const eventBundleCardStyles = (
	theme: Theme,
	hostPrimaryColorHex?: string,
	sx?: SxProps<Theme>
) => {
	const commStyles = commonStyles(theme);

	const primaryColorHex = hostPrimaryColorHex || defaultHostColorHex;

	return {
		root: clsx(
			commStyles.flexColumn,
			{
				gap: '24px',

				minWidth: 300,
				maxWidth: 620,
				width: '100%',

				borderRadius: '8px',

				border: '1px solid transparent',

				background: '#191919',

				borderColor: '#353535',
			},
			sx
		),
		content: clsx(commStyles.flexColumn, {
			p: '22px 18px 16px',
		}),
		header: clsx(commStyles.flexColumn, {
			gap: '6px',
		}),
		headerTitle: {
			color: Colors.white_a80,
			fontWeight: '500',
			fontSize: '10px',
			letterSpacing: '1px',
			textTransform: 'uppercase',
		},
		titleWrapper: {
			display: 'flex',
			alignItems: 'flex-start',
			marginBottom: '6px',
		},
		title: {
			fontFamily: 'Integral CF',
			fontSize: '20px',
			lineHeight: '158%',
			fontWeight: '500',
			color: Colors.white,
		},
		titleEvents: {
			marginTop: '7px',
			marginLeft: '5px',
			fontFamily: 'Montserrat',
			fontSize: '18px',
			lineHeight: '100%',
			fontWeight: '700',
			color: Colors.white_a90,
		},
		description: {
			color: Colors.white_a80,
			fontSize: '14px',
			fontWeight: '500',
			lineHeight: '130%',
		},
		typeGetButton: {
			fontSize: '14px',
			lineHeight: '120%',
			fontWeight: 600,
			maxWidth: '116px',
			marginTop: '16px',
			p: '10px 24px',
		},
	};
};
